import React, { Component } from 'react';

import classes from './Tracking.css';
import Icon from '../../../components/UI/Icon/Icon';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import carImg from '../../../assets/images/car-icon.png';
import editImg from '../../../assets/images/edit-icon.png';
import saveImg from '../../../assets/images/save-icon.png';
import closeWhiteImg from '../../../assets/images/close-white-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import openImg from '../../../assets/images/open-white-icon.png';
import moreImg from '../../../assets/images/more-white-icon.png';
import clockImg from '../../../assets/images/clock-icon.png';
import mapImg from '../../../assets/images/map-icon.png';
import arrowImg from '../../../assets/images/arrow-right-icon.png';
import axios from '../../../axios-trips';
import logError from '../../../store/LogError';
import phoneMoreImg from '../../../assets/images/phone-more-white-icon.png';
import warningImg from '../../../assets/images/warning-white-icon.png';
import archiveImg from '../../../assets/images/archive-icon.png';
import linkImg from '../../../assets/images/link-white-icon.png';
import warningOrangeImg from '../../../assets/images/warning-orange-icon.png';
import ButtonIcon from '../../../components/UI/ButtonIcon/ButtonIcon';
import Button from '../../../components/UI/Button/Button';
import Dropdown from '../../../components/UI/Dropdown/Dropdown';
import ButtonIconConfirm from '../../../components/UI/ButtonIconConfirm/ButtonIconConfirm';
import ContactModal from '../../../components/ContactModal/ContactModal';
import Modal from '../../../components/UI/Modal/Modal';
import ClientInfo from '../../TrackingPage/ClientInfo/ClientInfo';

class Tracking extends Component {

  state = {
    editing: false,
    closing: false,
    showContacts: false,
    showClientInfo: false,
    clientInfo1: "",
    clientInfo2: "",
    clientName: "",
  }

  componentDidMount() {
    if (this.props.editing) {
      this.setState({ editing: true });
    }
  }

  formatDatePretty(date) {
    if (date === undefined || date === null) {
      return null;
    }
    return date.substring(11, 16) + " " + date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4);
  }

  formatTime(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(11, 16).replace(/[^0-9]/g, "");
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(0, 10);
  }

  getTrackingLabel(status) {
    let trackingLabel = "В пути";
    if (status === 1) {
      trackingLabel = "Будет в течение часа";
    } else if (status === 2) {
      trackingLabel = "Разгружается";
    } else if (status === 3) {
      trackingLabel = "Выгружено";
    }
    return trackingLabel;
  }

  getImportTrackingLabel(status) {
    let trackingLabel = "В пути";
    if (status === 1) {
      trackingLabel = "Будет в течении часа";
    } else if (status === 2) {
      trackingLabel = "В процессе";
    } else if (status === 3) {
      trackingLabel = "Прошел";
    }
    return trackingLabel;
  }

  getImportHeaderTrackingLabel(status) {
    let trackingLabel = "";
    if (status === 1) {
      trackingLabel = "На загрузке";
    } else if (status === 2) {
      trackingLabel = "Вышел в рейс";
    }
    return trackingLabel;
  }

  updateAll() {
    for (let i = 0; i < this.props.tripTrackingStatus.tripTrackings.length; i++) {
      if (this.props.tripTrackingStatus.tripTrackings[i].forecast !== null && this.props.tripTrackingStatus.tripTrackings[i].forecast.length < 16) {
        this.props.addNotification("Пожалуйста, введите время в формате `0011` (часы - `00`, минуты - `11`).", "Danger");
        return;
      }
    }
    this.setState({ editing: false });
    this.props.updateAll();
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if (tomorrow.getMonth() < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  findRouteById(routeId) {
    if (this.props.routes) {
      for (let i = 0; i < this.props.routes.length; i++) {
        if (this.props.routes[i].id === routeId) {
          return this.props.routes[i];
        }
      }
    }
    return null;
  }

  getRouteName(route) {
    let routeName = route.id + ". ";
    route.tripPoints.forEach((tripPoint, index) => {
      if (index < route.tripPoints.length - 1) {
        routeName += tripPoint.location.locationName + " > ";
      } else {
        routeName += tripPoint.location.locationName;
      }
    });
    return routeName;
  }

  getTripRoute() {
    if (this.props.tripTrackingStatus.trip && this.props.tripTrackingStatus.trip.tripPoints) {
      let route = this.props.tripTrackingStatus.trip;
      let routeName = (
        route.tripPoints.map((tripPoint, index) => {
          return (
            <Aux>
            {
              index < route.tripPoints.length - 1 ?
              <Aux>
                <p>{tripPoint.location.locationName}</p>
                <Icon iconSource={arrowImg} iconClass={classes.ArrowIcon} />
              </Aux>
              :
              <Aux>
                <p>{tripPoint.location.locationName}</p>
              </Aux>
            }
            </Aux>
          );
        })
      );
      return routeName;
    } else {
      return null;
    }
  }

  getId(id) {
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  showClientInfo(index) {
    this.setState({
      showClientInfo: true,
      clientInfo1: this.props.tripTrackingStatus.tripTrackings[index].delivery1,
      clientInfo2: this.props.tripTrackingStatus.tripTrackings[index].delivery2,
      clientName: this.props.tripTrackingStatus.tripTrackings[index].clients
    });
  }

  resetDateTime(ev, index) {
    ev.preventDefault();
    this.props.changeTime({target: { value: null }}, index);
    this.props.changeDate({target: { value: null }}, index);
  }

  openTrip(ev) {
    this.setState({ editing: false });
    this.props.openTrip(
      ev, this.props.tripTrackingStatus.trip.id,
      this.props,
      this.props.tripTrackingStatus.driver ? this.props.tripTrackingStatus.driver.id : null
    );
  }

  generateMarkers() {
    for (let i = 0; i < this.props.tripTrackingStatus.tripTrackings.length; i++) {
      this.props.tripTrackingStatus.tripTrackings
    }
  }

  parsePhones() {
    if (this.state.clientInfo2 === null) {
      return [];
    }
    let phones = this.state.clientInfo2.replace(/[-|(| |)]/g, '');
    phones = phones.match(/\d+/g);
    if (phones === null) {
      return [];
    }

    let parsedPhones = [];
    for (let i = 0; i < phones.length; i++) {
      let phone = phones[i];
      if (phone.length > 10) {
        phone = phone.substring(phone.length - 10, phone.length);
      }

      if (phone.length === 10) {
        parsedPhones.push(phone);
      }
    }

    return parsedPhones;
  }

  render() {
    return (
      <Aux>
      <ContactModal
        close={(ev) => this.setState({ showContacts: false })}
        show={this.state.showContacts}
        noRestrictions={this.props.noRestrictions}
        driver={this.props.tripTrackingStatus.driver ? this.props.tripTrackingStatus.driver.id : null} />
      <ClientInfo
        modalClosed={(ev) => this.setState({ showClientInfo: false })}
        show={this.state.showClientInfo} >
        <h3>{ this.state.clientName }</h3>
        <p>{ this.state.clientInfo1 ? this.state.clientInfo1 : "" }</p>
        <br />
        <p>{ this.state.clientInfo2 ? this.state.clientInfo2 : "" }</p>
        <br />
        <hr />
        <br />
        <p>Потенциальные Телефоны:</p>
        <ul>
          {
            this.parsePhones().length === 0 ?
            <p><em>Не нашел подходящих телефонов</em></p>
            :
            this.parsePhones().map( phone => {
              return (
                <li>
                  <a href={"tel:" + phone}>{ phone }</a>
                </li>
              )
            })
          }
        </ul>
        <Button
          clicked={(ev) => this.setState({ showClientInfo: false })}
          extraClass={classes.ButtonClientInfo}
          btnType='Success'>
        ЗАКРЫТЬ
        </Button>
      </ClientInfo>
      <div className={classes.Tracking} style={this.props.noRestrictions ? { width: "100%", maxWidth: "100%" } : null}>
          <div className={classes.TrackingHeader}>
            <div className={classes.HeaderInfo}>

            { this.props.role === "ROLE_ADMIN" || this.props.role === "ROLE_DISPATCHER" ?
              <div className={classes.TrackingButtons}>
                <ButtonIcon
                  btnType='Success'
                  clicked={this.state.editing ? (ev) => this.updateAll() : (ev) => this.setState({ editing: !this.state.editing })}
                  iconClass={classes.ButtonIcon}
                  iconSource={this.state.editing ? saveImg : editImg }
                  small
                  style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                  iconAlt=''></ButtonIcon>
                {
                  this.state.editing ?
                    <ButtonIcon
                      btnType='Danger'
                      clicked={(ev) => this.setState({ editing: !this.state.editing })}
                      iconClass={[classes.ButtonIcon, classes.FadeIn].join(' ')}
                      iconSource={closeWhiteImg}
                      small
                      style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                      iconAlt=''></ButtonIcon>
                  : null
                }

                {
                  this.state.editing ?
                  <Aux>
                    <Dropdown
                      dropdown=""
                      dropIcon={moreImg}
                      dropIconClass={classes.MoreIcon}
                      extraClass={classes.DropdownClassButton}
                      className={classes.DropdownClass}>
                      { this.props.tripTrackingStatus.trip ?
                        <ButtonIcon
                          btnType='Success'
                          clicked={(ev) => this.openTrip(ev)}
                          iconClass={classes.ButtonIcon}
                          iconSource={openImg}
                          small
                          style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                          iconAlt=''></ButtonIcon>
                        : null }
                      { this.props.tripTrackingStatus.driver && this.props.tripTrackingStatus.driver.id ?
                        <ButtonIcon
                          btnType='Success'
                          clicked={(ev) => this.setState({ showContacts: true })}
                          iconClass={classes.ButtonIcon}
                          iconSource={phoneMoreImg}
                          small
                          style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                          iconAlt=''></ButtonIcon>
                       : null }
                       <ButtonIcon
                         btnType='Success'
                         clicked={this.props.generateLink}
                         iconClass={classes.ButtonIcon}
                         iconSource={linkImg}
                         small
                         style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                         iconAlt=''></ButtonIcon>
                       <ButtonIcon
                         btnType='Success'
                         clicked={this.props.openMap}
                         iconClass={classes.ButtonIcon}
                         iconSource={mapImg}
                         small
                         style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                         iconAlt=''></ButtonIcon>
                    </Dropdown>
                  </Aux>
                :
                <Dropdown
                  dropdown=""
                  dropIcon={moreImg}
                  dropIconClass={classes.MoreIcon}
                  className={classes.DropdownClass}
                  extraClass={classes.DropdownClassButton}>
                  <ButtonIconConfirm
                    btnType='Danger'
                    clicked={this.props.forceUnloadHandler}
                    iconClass={classes.ButtonIcon}
                    iconSource={archiveImg}
                    confirmText='архивировать отслежку'
                    small
                    style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                    iconAlt=''></ButtonIconConfirm>
                  { this.props.tripTrackingStatus.driver && this.props.tripTrackingStatus.driver.id ?
                    <ButtonIcon
                      btnType='Success'
                      clicked={(ev) => this.setState({ showContacts: true })}
                      iconClass={classes.ButtonIcon}
                      iconSource={phoneMoreImg}
                      small
                      style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                      iconAlt=''></ButtonIcon>
                   : null }
                  <ButtonIcon
                    btnType='Success'
                    clicked={this.props.generateLink}
                    iconClass={classes.ButtonIcon}
                    iconSource={linkImg}
                    small
                    style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                    iconAlt=''></ButtonIcon>
                  <ButtonIcon
                    btnType='Success'
                    clicked={this.props.openMap}
                    iconClass={classes.ButtonIcon}
                    iconSource={mapImg}
                    small
                    style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                    iconAlt=''></ButtonIcon>
                  </Dropdown>
                  }
              </div>
              : null }

              <p className={[classes.TrackingTitle, classes.Block].join(' ')}>
                <Icon iconSource={carImg} iconClass={classes.HeaderIcon} />
                <em>{this.props.tripTrackingStatus.car}</em>
              </p>
              {this.getTripRoute()}
              <p className={[classes.TrackingTitle, classes.Block].join(' ')}>Рейс {this.props.tripTrackingStatus.trip ? "#" + this.getId(this.props.tripTrackingStatus.trip.id) : null } | <em>{this.props.tripTrackingStatus.transportCode}</em></p>
            </div>
          </div>

          {
            this.state.editing ?
            <label className={classes.FadeIn}>
            Рейс:
              <select
                value={this.props.tripTrackingStatus.trip ? this.props.tripTrackingStatus.trip.id : "-"}
                onChange={(ev) => this.props.tripIdChanged(ev)} >
                  <option key="-1" value="-">
                    -
                  </option>
                  {
                    this.props.routes.map((route, index) => {
                      return (
                        <option
                          key={index}
                          value={route.id}>
                          { this.getRouteName(route) }
                        </option>
                      );
                    })
                  }
              </select>
            </label>
            : null
          }

          <div className={classes.TrackingBody}>
            { this.props.tripTrackingStatus.tripTrackings.map( (point, index) => {
              if (!point) {
                return (<div></div>);
              }
              let prevPoint = index > 0 ? this.props.tripTrackingStatus.tripTrackings[index - 1] : null;
              return (
                <div
                  className={classes.Point}
                  key={index}>
                  <div className={classes.PointProgress}>
                    {
                      index > 0 ?
                      <div className={[classes.Line, point.status >= 1 ? classes.LineActive : null, point.status >= 2 ? classes.LineComplete : null].join(' ')}>
                      </div>
                      : null
                    }

                    { this.state.editing && index > 0 ?
                      <div className={[classes.StatusHolder, classes.FadeIn].join(' ')}>
                        {
                          index === 1 && !this.props.tripTrackingStatus.transportCode &&
                          <Aux>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={prevPoint.status > 0}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 1 : 0, 0)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>На загрузке</p>
                            </label>
                            <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={prevPoint.status > 1}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 2 : 1, 0)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                            <p className={classes.StatusText}>Вышел в рейс</p>
                            </label>
                          </Aux>
                        }
                        {
                          index > 1 && index <= 3 &&
                          <Aux>
                            {
                              index === 1 &&
                              <p className={classes.BorderBottom}>Отправлен: { this.formatDatePretty(prevPoint.forecast) }</p>
                            }

                            { !this.props.tripTrackingStatus.transportCode &&
                              <Aux>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 0}
                                      type="checkbox"
                                      onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 1 : 0, index - 1)}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>Будет в течении часа</p>
                                </label>
                                <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 1}
                                      type="checkbox"
                                      onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 2 : 1, index - 1)}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                <p className={classes.StatusText}>В процессе</p>
                                </label>
                                <div className={[classes.Link, prevPoint.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                                <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                                  <div className={classes.CheckboxHolder}>
                                    <input
                                      className={classes.Checkbox}
                                      checked={prevPoint.status > 2}
                                      type="checkbox"
                                      onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 3 : 2, index - 1)}>
                                    </input>
                                    <span className={classes.Checkmark}></span>
                                  </div>
                                  <p className={classes.StatusText}>Прошел</p>
                                </label>
                              </Aux>
                            }
                          </Aux>
                        }

                        { (index > 1 || !this.props.tripTrackingStatus.transportCode) &&
                          <div className={classes.StatusLabel}>
                            <label className={classes.StatusLabel}>
                              <p className={classes.LabelText}>Авария</p>
                              <input
                                checked={prevPoint.crash}
                                type="checkbox"
                                onChange={(ev) => this.props.updateCrash(ev, index - 1)}>
                              </input>
                            </label>

                            {
                              prevPoint.crash &&
                                <input
                                  type="text"
                                  value={prevPoint.comment}
                                  onChange={(ev) => this.props.updateComment(ev, index - 1)}></input>
                            }
                            <p className={classes.LabelText}>Ожидается</p>
                            <input
                              type="text"
                              maxLength="4"
                              value={prevPoint.forecast ? this.formatTime(prevPoint.forecast) : "----"}
                              onChange={(ev) => this.props.changeTime(ev, index - 1)}></input>
                            <input
                              type="date"
                              value={prevPoint.forecast ? this.formatDate(prevPoint.forecast) : this.getTodayDate()}
                              onChange={(ev) => this.props.changeDate(ev, index - 1)}></input>
                            <ButtonIcon
                              btnType='Clear'
                              clicked={(ev) => this.resetDateTime(ev, index - 1)}
                              iconClass={classes.ButtonIcon}
                              iconSource={closeImg}
                              small
                              style={{width: "auto", display: "inline-block", marginLeft: "5px", height: "auto"}}
                              iconAlt=''></ButtonIcon>
                            <p>(обновлено: {this.formatDatePretty(prevPoint.forecastMod)})</p>
                          </div>
                        }

                        { ((index > 1 && this.props.tripTrackingStatus.transportCode) || (index > 3 && !this.props.tripTrackingStatus.transportCode)) &&
                          <Aux>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={prevPoint.status > 0}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 1 : 0, index - 1)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>Будет в течение часа</p>
                            </label>
                            <div className={[classes.Link, prevPoint.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={prevPoint.status > 1}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 2 : 1, index - 1)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                            <p className={classes.StatusText}>Разгружается</p>
                            </label>
                            <div className={[classes.Link, prevPoint.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={prevPoint.status > 2}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 3 : 2, index - 1)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>Выгружено</p>
                            </label>
                          </Aux> }
                      </div>
                      :

                      index > 0 ?
                      <div className={classes.StatusHolder}>
                        {
                          index === 1 &&
                          this.props.tripTrackingStatus.transportCode &&
                          <p
                            className={[classes.BorderBottom, classes.TextSmall].join(' ')}>
                            Отправлен: { this.formatDatePretty(prevPoint.forecast) }
                          </p>
                        }

                        {
                          prevPoint.forecast && prevPoint.status === 0 ?
                            index < this.props.tripTrackingStatus.tripTrackings.length - 1 && this.props.tripTrackingStatus.tripTrackings[index + 1].status === 0 ?
                              <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                                <div>
                                  <Icon
                                   iconSource={clockImg}
                                   iconClass={classes.ClockIcon} />
                                   <p>{this.formatDatePretty(prevPoint.forecast)}</p>
                                </div>
                              </label>
                            :
                              <label className={[classes.StatusLabel, classes.BorderBottom, classes.TextSmall].join(' ')}>
                                <div>
                                  <Icon
                                   iconSource={clockImg}
                                   iconClass={classes.ClockIcon} />
                                   <p>{this.formatDatePretty(prevPoint.forecast)}</p>
                                </div>
                              </label>

                          :
                            index === 1 &&
                            !this.props.tripTrackingStatus.transportCode &&
                            prevPoint.status < 2 ?
                            <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                              <p><em>{ this.getImportHeaderTrackingLabel(prevPoint.status) }</em></p>
                            </label>
                          :
                            index <= 3 && !this.props.tripTrackingStatus.transportCode &&
                            prevPoint.status < 3 &&
                            this.props.tripTrackingStatus.tripTrackings[index - 2] &&
                            this.props.tripTrackingStatus.tripTrackings[index - 2].status > 1 ?
                            <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                              <p><em>{ this.getImportTrackingLabel(prevPoint.status) }</em></p>
                            </label>
                            :
                            prevPoint.status < 3 &&
                            (this.props.tripTrackingStatus.transportCode || (!this.props.tripTrackingStatus.transportCode && index > 3)) &&
                            this.props.tripTrackingStatus.tripTrackings[index - 2] &&
                            this.props.tripTrackingStatus.tripTrackings[index - 2].status !== 0 &&
                            <label className={[classes.StatusLabel, classes.BorderBottom].join(' ')}>
                              <p><em>{ this.getTrackingLabel(prevPoint.status) }</em></p>
                            </label>
                         }
                         {
                            point.crash ?
                            <Aux>
                              <div className={classes.BorderTop}>
                                <Icon
                                 iconSource={point.status >= 3 ? warningOrangeImg : warningImg}
                                 iconClass={[classes.CrashIcon, point.status < 3 ? classes.Pulse : null].join(' ')} />
                                <p>Авария:</p>
                              </div>
                              <p>{point.comment}</p>
                            </Aux>
                            : null
                         }
                      </div>
                      : null
                    }

                  </div>
                  <div>
                    {
                      (index > 0 && prevPoint.status >= 3 && point && point.status < 3) ||
                      index === this.props.tripTrackingStatus.tripTrackings.length - 1 && prevPoint && prevPoint.status >= 3 ?
                      <p className={[classes.Index, classes.IndexMain, point && point.status >= 3 ? classes.IndexActive : null].join(' ')}>{index + 1}</p> :
                      <p className={[classes.Index, point.status >= 2 ? classes.IndexActive : null].join(' ')}>{index + 1}</p>
                    }

                    <div
                      className={classes.Inline}
                      onClick={this.props.tripTrackingStatus.tripTrackings[index].delivery1 || this.props.tripTrackingStatus.tripTrackings[index].delivery2 ?
                              (ev) => this.showClientInfo(index) : null}>
                      {
                        (index > 0 && prevPoint.status >= 3 && point.status < 3) ||
                        index === this.props.tripTrackingStatus.tripTrackings.length - 1 && prevPoint.status >= 3 ?
                        <p className={this.props.tripTrackingStatus.tripTrackings[index].delivery1 ||
                                      this.props.tripTrackingStatus.tripTrackings[index].delivery2 ?
                                      classes.ClientLink : classes.ClientLinkDull}>{point.clients}</p>
                        :
                        <p className={this.props.tripTrackingStatus.tripTrackings[index].delivery1 ||
                                      this.props.tripTrackingStatus.tripTrackings[index].delivery2 ?
                                      classes.ClientLinkFaded : classes.ClientLinkDullFaded}>{point.clients}</p>

                      }
                      <p className={classes.Managers}>{point.managers}</p>
                    </div>
                    { this.state.editing && index === this.props.tripTrackingStatus.tripTrackings.length - 1 ?
                      <div className={[classes.StatusHolder, classes.FadeIn].join(' ')}>
                        { (index > 0 || !this.props.tripTrackingStatus.transportCode) &&
                          <div className={classes.StatusLabel}>
                            <p className={classes.LabelText}>Ожидается</p>
                            <input
                              type="text"
                              maxLength="4"
                              value={point.forecast ? this.formatTime(point.forecast) : "----"}
                              onChange={(ev) => this.props.changeTime(ev, index)}></input>
                            <input
                              type="date"
                              value={point.forecast ? this.formatDate(point.forecast) : this.getTodayDate()}
                              onChange={(ev) => this.props.changeDate(ev, index)}></input>
                            <ButtonIcon
                              btnType='Clear'
                              clicked={(ev) => this.resetDateTime(ev, index)}
                              iconClass={classes.ButtonIcon}
                              iconSource={closeImg}
                              small
                              style={{width: "auto", display: "inline-block", marginLeft: "5px", height: "auto"}}
                              iconAlt=''></ButtonIcon>
                            <p>(обновлено: {this.formatDatePretty(point.forecastMod)})</p>
                          </div>
                        }

                        { index > 0 ?
                          <Aux>
                            <label className={classes.StatusLabel}>
                              <p className={classes.LabelText}>Авария</p>
                              <input
                                checked={point.crash}
                                type="checkbox"
                                onChange={(ev) => this.props.updateCrash(ev, index)}>
                              </input>
                            </label>

                            {
                              point.crash ?
                                <input
                                  type="text"
                                  value={point.comment}
                                  onChange={(ev) => this.props.updateComment(ev, index)}></input>
                              : null
                            }
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={point.status > 0}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 1 : 0, index)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>Будет в течение часа</p>
                            </label>
                            <div className={[classes.Link, point.status > 1 ? classes.LinkActive : null].join(' ')}></div>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={point.status > 1}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 2 : 1, index)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>Разгружается</p>
                            </label>
                            <div className={[classes.Link, point.status > 2 ? classes.LinkActive : null].join(' ')}></div>
                            <label className={[classes.StatusLabel, classes.StatusPadding].join(' ')}>
                              <div className={classes.CheckboxHolder}>
                                <input
                                  className={classes.Checkbox}
                                  checked={point.status > 2}
                                  type="checkbox"
                                  onChange={(ev) => this.props.updateStatusHandler(ev, ev.target.checked ? 3 : 2, index)}>
                                </input>
                                <span className={classes.Checkmark}></span>
                              </div>
                              <p className={classes.StatusText}>Выгружено</p>
                            </label>
                            <div>
                              <p className={classes.LabelText}>Последняя Выгрузка</p>
                              <input
                                type="date"
                                value={this.props.tripTrackingStatus.unloaded ? this.formatDate(this.props.tripTrackingStatus.unloaded) : null}
                                onChange={(ev) => this.props.changeUnloaded(ev)}></input>
                              <ButtonIcon
                                btnType='Clear'
                                clicked={(ev) => this.props.changeUnloaded({target: { value: null }})}
                                iconClass={classes.ButtonIcon}
                                iconSource={closeImg}
                                small
                                style={{width: "auto", display: "inline-block", marginLeft: "5px"}}
                                iconAlt=''></ButtonIcon>
                            </div>
                            {
                              this.props.tripTrackingStatus.lastChange ?
                              <div
                                 className={classes.BorderTop}
                                 style={{color: "#4f4f4f", fontSize: "14px"}}>
                                 Последнее обновление:<br />{this.formatDatePretty(this.props.tripTrackingStatus.lastChange)}
                                 <br />
                                 (обновил: { this.props.tripTrackingStatus.lastChangeSource})
                               </div>
                              : null
                            }
                          </Aux>
                        : null }
                      </div>
                      :

                      index === this.props.tripTrackingStatus.tripTrackings.length - 1 ?
                      <div className={classes.StatusHolder}>
                        { point.forecast && point.status === 0 ?
                          <label className={classes.StatusLabel}>
                            <div>
                              <Icon
                               iconSource={clockImg}
                               iconClass={classes.ClockIcon} />
                               <p>{this.formatDatePretty(point.forecast)}</p>
                            </div>
                          </label>
                          :
                            point.status < 3 && prevPoint.status !== 0 ?
                            <label className={classes.StatusLabel}>
                              <p><em>{ this.getTrackingLabel(point.status) }</em></p>
                            </label>
                            : null
                         }
                         {
                           this.props.tripTrackingStatus.lastChange ?
                           <div
                              className={classes.BorderTop}
                              style={{color: "#4f4f4f", fontSize: "14px"}}>
                              Последнее обновление:<br />{this.formatDatePretty(this.props.tripTrackingStatus.lastChange)}
                              <br />
                              (обновил: { this.props.tripTrackingStatus.lastChangeSource})
                            </div>
                           : null
                         }
                      </div>
                      : null }
                  </div>
                </div>
              );
            } ) }
          </div>
      </div>
      </Aux>
    );
  }
}

export default Tracking;



// WEBPACK FOOTER //
// ./src/containers/TripTracking/Tracking/Tracking.js